// extracted by mini-css-extract-plugin
export default {"root":"o5rO01","mobile":"f1RDz8"};